import { render, staticRenderFns } from "./riskManagement.vue?vue&type=template&id=1ce88f47&scoped=true&"
import script from "./riskManagement.vue?vue&type=script&lang=js&"
export * from "./riskManagement.vue?vue&type=script&lang=js&"
import style0 from "./riskManagement.vue?vue&type=style&index=0&id=1ce88f47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce88f47",
  null
  
)

export default component.exports